module.exports = __webpack_public_path__ + "img/google-play-id.2b24d61.png";